import React, { useMemo } from 'react';
import Pagination from '@material-ui/lab/Pagination';
import { colors } from 'src/config/colors';
import styled from 'styled-components';
import { typography } from 'src/config/typography';

const Container = styled.div`
  margin-top: 1.25rem;
  align-self: center;

  .MuiPagination-ul .Mui-selected {
    background-color: ${colors.red};
  }

  .MuiPagination-ul {
    display: flex;
    gap: 15px;

    button {
      font-family: ${typography.fontFamilyHeaders};
      font-size: 1rem;
      line-height: 1.375rem;
    }
  }

  .MuiPagination-ul svg {
    width: 1.875rem;
    height: 1.875rem;
    color: ${colors.blue};
  }
`;

interface CourseListingPaginationProps {
  totalResult?: number;
  pageSize?: number;
  currentPage?: number;
  handlePageChange?: (p: number) => void;
}

export const CourseListingPaginationControl = ({
  totalResult,
  pageSize,
  currentPage = 1,
  handlePageChange,
}: CourseListingPaginationProps) => {
  // todo: poprawny typ
  // eslint-disable-next-line @typescript-eslint/ban-types
  const handleChange = (event: object, page: number) => {
    if (handlePageChange) {
      handlePageChange(page);
    }
  };

  const pageCount = useMemo(() => {
    if (!totalResult || !pageSize) {
      return 0;
    }
    return Math.ceil(totalResult / pageSize);
  }, [totalResult, pageSize]);

  return (
    <Container>
      <Pagination
        hidePrevButton={currentPage === 1}
        hideNextButton={currentPage === pageCount}
        size="small"
        onChange={handleChange}
        count={pageCount}
        color="secondary"
        page={currentPage}
      />
    </Container>
  );
};
